import { createBrowserRouter } from "react-router-dom";
import AdminPage from "../pages/admin/admin_page";

const lazyErrorBoundary = async () => {
  const { ErrorRenderer } = await import("shared-lib");
  return ErrorRenderer;
};

export const router = createBrowserRouter([
  {
    path: "/",
    lazy: {
      Component: async () => (await import("../pages/root/root")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/pdf_scanner",
    lazy: {
      Component: async () =>
        (await import("../pages/pdf_scanner/overview_page/pdf_scanner")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/pdf_scanner/detail/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/pdf_scanner/detail_page/job_detail")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/pdf_scanner_v4",
    lazy: {
      Component: async () =>
        (await import("../pages/pdf_scanner_v4/overview_page/pdf_scanner_v4")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/pdf_scanner_v4/detail/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/pdf_scanner_v4/detail_page/job_detail_v4")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/tour_planner",
    lazy: {
      Component: async () =>
        (await import("../pages/tour_planner/tour_planner")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/offer_generation",
    lazy: {
      Component: async () =>
        (await import("../pages/offer_generation/overview/offer_generation_overview")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/offer_generation/offer/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/offer_generation/offers/edit/edit_offer_screen")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/offer_generation/template/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/offer_generation/template/edit/edit_template")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/offer_generation/faulty-imports",
    lazy: {
      Component: async () =>
        (await import("../pages/offer_generation/faulty_imports/faulty_imports")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/customers",
    lazy: {
      Component: async () =>
        (await import("../pages/customers/customer_overview")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/customers/:customerNumber/containers/:containerId",
    lazy: {
      Component: async () =>
        (await import("../pages/containers/details/container_detail_page")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/containers",
    lazy: {
      Component: async () =>
        (await import("../pages/containers/containers_overview")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/products",
    lazy: {
      Component: async () =>
        (await import("../pages/products/product_overview")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/steel_mind",
    lazy: {
      Component: async () =>
        (await import("../pages/steel_mind/sm_overview")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/steel_mind/order/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/steel_mind/sm_order_detail")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/order_inbox",
    lazy: {
      Component: async () =>
        (await import("../pages/order_inbox/order_inbox_overview")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/order_inbox/detail/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/order_inbox/order_inbox_detail")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/auftrag/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/auftrag/auftrag_detail")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/arbeitsvorbereitung",
    lazy: {
      Component: async () =>
        (await import("../pages/arbeitsvorbereitung/arbeitsvorbereitung"))
          .default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/email_settings",
    lazy: {
      Component: async () =>
        (await import("../pages/email-settings/email_settings")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/email-settings/template/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/email-settings/templates/edit_email_template")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/email/draft/:id",
    lazy: {
      Component: async () =>
        (await import("../pages/email/edit_email_draft")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/user-management",
    lazy: {
      Component: async () =>
        (await import("../pages/user-management/user_management_overview")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/feedback-review",
    lazy: {
      Component: async () =>
        (await import("../pages/feedback-review/feedback_review_page")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/secrets-management",
    lazy: {
      Component: async () =>
        (await import("../pages/secrets-management/secrets_management_overview")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
  },
  {
    path: "/admin",
    lazy: {
      Component: async () =>
        (await import("../pages/admin/admin_page")).default,
      ErrorBoundary: lazyErrorBoundary,
    },
    children: [
      {
        path: "",
        lazy: {
          Component: async () =>
            (await import("../pages/admin/admin_page")).default,
          ErrorBoundary: lazyErrorBoundary,
        },
      },
      {
        path: "dashboard",
        lazy: {
          Component: async () =>
            (await import("../pages/admin/admin_page")).default,
          ErrorBoundary: lazyErrorBoundary,
        },
      },
      {
        path: "tenants",
        lazy: {
          Component: async () =>
            (await import("../pages/admin/admin_page")).default,
          ErrorBoundary: lazyErrorBoundary,
        },
      },
      {
        path: "shadow-products",
        element: <AdminPage />,
      },
      {
        path: "billing",
        lazy: {
          Component: async () =>
            (await import("../pages/admin/admin_page")).default,
          ErrorBoundary: lazyErrorBoundary,
        },
      },
      {
        path: "feedback",
        lazy: {
          Component: async () =>
            (await import("../pages/admin/admin_page")).default,
          ErrorBoundary: lazyErrorBoundary,
        },
      },
    ],
  },
]);
